// extracted by mini-css-extract-plugin
export var baseButton = "_q8-0";
export var controlsArrowKeys = "_q8-1";
export var controlsResetButton = "_q8-2";
export var lightGameButton = "_q8-4 _q8-0";
export var playAgainButton = "_q8-5 _q8-0";
export var startGameButton = "_q8-3 _q8-0";